<template>

    <div class="header-wrapper" :class="{ scrolled: isScrolled }">

        <div class="container">

            <nav class="navbar navbar-expand-lg">

                <div class="container-fluid px-0">

                    <button
                        class="navbar-toggler"
                        type="button"
                        :aria-expanded="isMenuOpen.toString()"
                        aria-label="Navigation umschalten"
                        @click.stop="toggleMenu"
                    >
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="navbar-collapse" :class="{ show: isMenuOpen }">

                        <ul class="navbar-nav ms-auto">

                            <li class="nav-item">
                                <a class="nav-link" href="#" @click.prevent="navTo('home')">Home</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" href="#" @click.prevent="navTo('about')">Über mich</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" href="#" @click.prevent="navTo('services')">Leistungen</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" href="#" @click.prevent="navTo('contact')">Kontakt</a>
                            </li>

                        </ul>

                    </div>

                </div>

            </nav>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheNavbarComponent',

        data() {

            return {

                isScrolled: false,
                isMenuOpen: false,

            }

        },

        mounted() {

            window.addEventListener('scroll', this.handleScroll)
            document.addEventListener('click', this.handleOutsideClick)

        },

        beforeUnmount() {

            window.removeEventListener('scroll', this.handleScroll)
            document.removeEventListener('click', this.handleOutsideClick)

        },

        methods: {

            handleScroll() {

                this.isScrolled = window.scrollY > 60

            },

            toggleMenu() {

                this.isMenuOpen = !this.isMenuOpen

            },

            handleOutsideClick() {

                this.isMenuOpen = false

            },

            navTo(id) {

                this.isMenuOpen = false
                const el = document.getElementById(id)
                if (!el) return
                el.scrollIntoView({ behavior: 'smooth', block: 'start' })

            },

        },

    }

</script>

<style scoped>

    .header-wrapper {

        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 100;
        background: transparent;
        transition: background 0.35s ease, box-shadow 0.35s ease;

    }

    .header-wrapper.scrolled {

        background: rgba(7, 13, 26, 0.92);
        backdrop-filter: blur(10px);
        box-shadow: 0 1px 0 rgba(0, 180, 255, 0.1);

    }

    .navbar-collapse {

        display: none;

    }

    .navbar-collapse.show {

        display: block;

    }

    @media (min-width: 992px) {

        .navbar-collapse {

            display: flex !important;

        }

    }

.nav-link {

        color: rgba(255, 255, 255, 0.75) !important;
        font-size: 0.9rem;
        letter-spacing: 0.04em;
        padding: 0.5rem 1rem !important;
        transition: color 0.2s ease;

    }

    .nav-link:hover {

        color: #ffffff !important;

    }

    .navbar-toggler {

        border-color: rgba(0, 180, 255, 0.4);

    }

    .navbar-toggler-icon {

        filter: invert(1);

    }

</style>
